import { FC, ReactNode } from 'react';
import { Section, Bullets, ApplyButton } from 'components';
import { color } from 'style';
import S from './ApplyReasonsSection.Styled';

interface ApplyReasonsSectionProps {
  backgroundColor?: string;
  heading: string;
  bullets: string[];
  applyLink?: string;
  disableApply?: boolean;
  unavailableContent?: ReactNode;
  onApply?: () => void;
}

export const ApplyReasonsSection: FC<ApplyReasonsSectionProps> = ({
  backgroundColor,
  heading,
  bullets,
  applyLink,
  disableApply,
  unavailableContent,
  onApply,
}) => {
  return (
    <Section backgroundColor={backgroundColor}>
      <S.Content>
        <S.Headings>
          <S.Heading>{heading}</S.Heading>
        </S.Headings>
        <S.BulletsContainer>
          <Bullets bullets={bullets} showOrder />
        </S.BulletsContainer>
        {applyLink && onApply && (
          <S.ButtonContainer>
            <ApplyButton
              primaryColor={color.hmBrandPurple}
              secondaryColor={color.white}
              href={applyLink}
              unavailable={disableApply}
              unavailableContent={unavailableContent}
              onClick={onApply}
            />
          </S.ButtonContainer>
        )}
      </S.Content>
    </Section>
  );
};
